module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__modal",
    class: {
      'out': _vm.isActive === false, 'blowup': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        {
          _vm.$emit('closeModal')
        }
      }
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_vm._t("modal-body"), _vm._v(" "), _c('span', {
    staticClass: "system-builder__modal--close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e552fb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/modal.vue
// module id = 428
// module chunks = 1